import { useQuery } from '@tanstack/react-query'
import { useAuthenticatedClient, queryKeys } from '@/api/queries'
import type { components } from '@/api/schema'

export type CustomerThreadSummary = components['schemas']['CustomerCommunicationThreadRead']

/** Every conversation with the customer, newest first: emails, texts and calls (USA-1695). */
export function useCustomerThreads(customerGroupId: number) {
  const getClient = useAuthenticatedClient()
  return useQuery({
    queryKey: queryKeys.customerComms.byCustomerGroup(customerGroupId),
    queryFn: async () => {
      const client = await getClient()
      const { data, error } = await client.GET('/dashboard/customer-communications/by-customer-group/{group_id}', {
        params: { path: { group_id: customerGroupId } },
      })
      if (error) throw error
      return data
    },
    enabled: customerGroupId > 0,
  })
}
